(function() {
  'use strict';

  function renderBundleComponents() {
    var bundleContainers = document.querySelectorAll('.cart__item--bundle-components[data-bundle-items]');
    
    bundleContainers.forEach(function(container) {
      if (container.dataset.rendered === 'true') {
        return;
      }
      
      var bundleItemsJson = container.dataset.bundleItems;
      if (!bundleItemsJson) {
        return;
      }
      
      try {
        var variantIds = JSON.parse(bundleItemsJson);
        if (!Array.isArray(variantIds) || variantIds.length === 0) {
          return;
        }
        
        container.innerHTML = '';
        
        variantIds.forEach(function(variantId) {
          fetchVariantInfo(variantId, function(variantData) {
            if (variantData) {
              var componentDiv = document.createElement('div');
              componentDiv.className = 'cart__bundle-component';
              
              var titleSpan = document.createElement('span');
              titleSpan.className = 'cart__bundle-component__title';
              titleSpan.textContent = variantData.product_title || variantData.title || 'Product';
              
              var variantSpan = document.createElement('span');
              variantSpan.className = 'cart__bundle-component__variant';
              if (variantData.title && variantData.title !== 'Default Title') {
                variantSpan.textContent = ' - ' + variantData.title;
              }
              
              componentDiv.appendChild(titleSpan);
              componentDiv.appendChild(variantSpan);
              container.appendChild(componentDiv);
            }
          });
        });
        
        container.dataset.rendered = 'true';
      } catch (e) {
        console.error('Error parsing bundle items:', e);
      }
    });
  }

  function fetchVariantInfo(variantId, callback) {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        var variant = null;
        
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.variant_id === variantId) {
            variant = {
              id: item.variant_id,
              title: item.variant_title,
              product_title: item.product_title
            };
            break;
          }
        }
        
        if (variant) {
          callback(variant);
        } else {
          callback({
            id: variantId,
            title: 'Variant ' + variantId,
            product_title: 'Bundle Component'
          });
        }
      })
      .catch(function() {
        callback({
          id: variantId,
          title: 'Variant ' + variantId,
          product_title: 'Bundle Component'
        });
      });
  }

  function init() {
    renderBundleComponents();
    
    document.addEventListener('ajaxProduct:added', function() {
      setTimeout(renderBundleComponents, 500);
    });
    
    document.addEventListener('cart:refresh', function() {
      setTimeout(renderBundleComponents, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
